import { GET_DEMOGRAPHICS_COMPARE, RESET_DEMOGRAPHICS_COMPARE } from '../types/demographics';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface DemographicsCompareState {
  demographics: any;
}

const INITIAL_STATE = {
  demographics: null,
} as DemographicsCompareState;

const demographicsCompareReducer = function (state = INITIAL_STATE, action: PayloadAction<any>):
DemographicsCompareState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_DEMOGRAPHICS_COMPARE:
      return { ...state, demographics: action.payload };
    case RESET_DEMOGRAPHICS_COMPARE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default demographicsCompareReducer;
